export const addLocation = id => {
  return (dispatch, getState) => {
    let isAvailable = id => {
      let temp = JSON.parse(JSON.stringify(getState().selectedLocations));
      let item = temp.find(location => {
        return location === id;
      });
      if (item) {
        return true;
      }
      return false;
    };

    if (id === "all") {   
      dispatch({
        type: "EMPTY_LIST"
      });
      return;
    }
    if (isAvailable(id)) {
      dispatch({
        type: "REMOVE_LOCATION",
        id
      });
     
    } else {
      if (
        getState().selectedLocations.length ===
        getState().auth.filters.locations.length - 2
      ) {
        dispatch({
          type: "EMPTY_LIST"
        });
      } else {
        dispatch({
          type: "ADD_LOCATION",
          id
        });
      }
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/filterLocation/filterLocationActions.js